import { memo } from "react";

import { Trans } from "react-i18next";

import ContactUs from "./ContactUs";
import DownloadLink from "./DownloadLink";

const UnsupportedVersionMessage = ({
  browserName,
  browserVersion,
  className = "",
  downloadPageLink,
  requiredMinBrowserVersion,
}) => (
  <Trans
    i18nKey="neetoMolecules.browserSupport.unsupportedBrowserVersion.description"
    components={{
      downloadLink: <DownloadLink {...{ className }} link={downloadPageLink} />,
      contactUs: <ContactUs {...{ className }} />,
    }}
    values={{
      browserName,
      browserVersion,
      requiredMinBrowserVersion: requiredMinBrowserVersion?.softLimit,
    }}
  />
);

export default memo(UnsupportedVersionMessage);
